/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type PresentOnAdmission = 0 | 1 | 2 | 3;

export const PresentOnAdmission = {
  NUMBER_0: 0 as PresentOnAdmission,
  NUMBER_1: 1 as PresentOnAdmission,
  NUMBER_2: 2 as PresentOnAdmission,
  NUMBER_3: 3 as PresentOnAdmission
};
